import { render, staticRenderFns } from "./Play_Dtl.vue?vue&type=template&id=0d0c0359&scoped=true"
import script from "./Play_Dtl.vue?vue&type=script&lang=js"
export * from "./Play_Dtl.vue?vue&type=script&lang=js"
import style0 from "./Play_Dtl.vue?vue&type=style&index=0&id=0d0c0359&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0c0359",
  null
  
)

export default component.exports